module.exports = __webpack_public_path__ + "static/media/bolt-slash-solid-white.673e2be2.svg";